module.exports = __webpack_public_path__ + "img/secondary-upload-file-icon.af25ccd7.svg";